// The app reads query strings as URLSearchParams, so the router must not JSON-encode
// or coerce them (TanStack's default does both, and repeated keys become an array).

export const parseSearch = (searchStr: string) => {
  const search: Record<string, string | string[]> = {};

  new URLSearchParams(searchStr).forEach((value, key) => {
    const existing = search[key];
    search[key] = existing === undefined ? value : [existing, value].flat();
  });

  return search;
};

export const stringifySearch = (search: Record<string, unknown>) => {
  const params = new URLSearchParams();

  Object.entries(search).forEach(([key, value]) => {
    [value].flat().forEach((item) => {
      if (item !== undefined) {
        params.append(key, String(item));
      }
    });
  });

  const query = params.toString();

  return query ? `?${query}` : "";
};

export const hrefWithQuery = (pathname: string, query: string) =>
  query ? `${pathname}?${query}` : pathname;
